import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logoRHR from '../assets/logo-RHR.png';
const DonationForm = () => {
  // Function to open PayPal donation with hosted button8CXPETXAAX8SW
  const openDonationPopup = () => {
    const donationUrl = 'https://paypal.com/donate/?hosted_button_id=DN2YF96AXZG7Q&source=url';
    window.open(donationUrl, '_blank');
  };

  return (
    <div className="bg-white p-8 rounded-lg h-full flex flex-col">
      <div className="flex flex-col items-center justify-center h-full">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-primary mb-4">
            Sostieni la nostra missione
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Con PayPal puoi scegliere l'importo, decidere se fare una donazione singola o ricorrente,
            e coprire le commissioni di transazione se desideri.
          </p>
        </div>
        
        <div className="bg-gray-50 p-6 rounded-xl mb-8 w-full max-w-md">
          <div className="text-center">
            <div className="bg-primary/10 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h3 className="font-semibold text-primary mb-2">Donazione Sicura</h3>
            <p className="text-sm text-gray-600">Tutte le donazioni sono gestite in modo sicuro da PayPal</p>
          </div>
        </div>
        
        <button 
          onClick={openDonationPopup}
          className="bg-blue-600 text-white py-4 px-8 rounded-lg font-semibold hover:bg-blue-700 transition duration-300 inline-flex items-center gap-3 text-lg shadow-lg transform hover:scale-105 mb-4"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h8.418c2.608 0 4.623.59 5.876 1.719 1.153 1.04 1.746 2.631 1.746 4.426 0 2.29-.793 4.006-2.032 5.06-1.239 1.054-3.084 1.615-5.424 1.615h-1.761L10.94 21.338a.641.641 0 0 1-.633.74H7.076zm2.89-13.134h2.17c.862 0 1.518-.187 1.97-.561.451-.374.677-.935.677-1.683 0-.748-.226-1.309-.677-1.683-.452-.374-1.108-.561-1.97-.561H9.966L9.966 8.203z"/>
            <path d="M16.023 0C17.662.024 18.86.339 19.616.944c.757.605 1.135 1.478 1.135 2.619 0 1.141-.378 2.014-1.135 2.619-.756.605-1.954.92-3.593.944h-1.616l-.865 5.123h-2.47L12.407 0h3.616z"/>
          </svg>
          Dona con PayPal
        </button>
        
        <p className="text-sm text-gray-600 text-center mb-6">
          Sistema di donazione sicuro - Si aprirà PayPal per completare la donazione
        </p>
        
        <div className="bg-blue-50 p-4 rounded-lg w-full max-w-md">
          <h4 className="font-semibold text-blue-800 mb-2">Con PayPal puoi:</h4>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>• Scegliere l'importo della donazione</li>
            <li>• Decidere se fare una donazione singola o ricorrente</li>
            <li>• Scegliere se coprire le commissioni di transazione</li>
            <li>• Donare in modo sicuro e protetto</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const VolunteerForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [area, setArea] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    alert("Grazie per il tuo interesse! Ti contatteremo presto.");
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <h3 className="text-xl font-semibold mb-4 text-primary">Diventa Volontario</h3>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-2" htmlFor="volunteer-name">
          Nome e Cognome
        </label>
        <input
          id="volunteer-name"
          type="text"
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-2" htmlFor="volunteer-email">
          Email
        </label>
        <input
          id="volunteer-email"
          type="email"
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-2" htmlFor="volunteer-phone">
          Telefono
        </label>
        <input
          id="volunteer-phone"
          type="tel"
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-2" htmlFor="volunteer-area">
          Area di Interesse
        </label>
        <select
          id="volunteer-area"
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
          value={area}
          onChange={(e) => setArea(e.target.value)}
          required
        >
          <option value="">Seleziona un'area</option>
          <option value="eventi">Organizzazione Eventi</option>
          <option value="raccolta-fondi">Raccolta Fondi</option>
          <option value="supporto-famiglie">Supporto Famiglie</option>
          <option value="comunicazione">Comunicazione</option>
          <option value="amministrazione">Amministrazione</option>
          <option value="altro">Altro</option>
        </select>
      </div>
      
      <div className="mb-6">
        <label className="block text-gray-700 mb-2" htmlFor="volunteer-message">
          Messaggio
        </label>
        <textarea
          id="volunteer-message"
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary h-32"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Raccontaci qualcosa di te e perché vuoi unirti a noi..."
        />
      </div>
      
      <button
        type="submit"
        className="w-full bg-primary text-white py-2 px-4 rounded-lg font-semibold hover:bg-primary/90 transition duration-300"
      >
        Invia Richiesta
      </button>
    </form>
  );
};

const Sostienici = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* Hero Section */}
      <div className="bg-red-600 text-white py-20 px-4">
        <div className="container mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 uppercase">Sostieni Robin Hood Roma ODV</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-semibold">
            Il tuo supporto può fare la differenza nella vita dei bambini e adolescenti 
            affetti da malattie ematologiche rare.
          </p>
        </div>
      </div>

      {/* Sezione Donazioni */}
      <section id="donazioni" className="py-16 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:items-stretch">
            {/* Colonna sinistra - Intro */}
            <div className="lg:col-span-1">
              <div className="sticky top-8 bg-white rounded-2xl shadow-xl overflow-hidden transform hover:shadow-2xl transition-all duration-500 h-fit lg:h-full">
                <div className="relative h-full">
                  {/* Background Pattern */}
                  <div className="absolute inset-0 bg-gradient-to-br from-accent/5 to-primary/5">
                    <div className="absolute inset-0" style={{
                      backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(0,0,0,0.05) 1px, transparent 0)',
                      backgroundSize: '20px 20px'
                    }}></div>
                  </div>
                  
                  {/* Content */}
                  <div className="relative p-8 flex flex-col h-full">
                    <h2 className="text-3xl font-bold text-primary mb-6 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                      Fai una Donazione
                    </h2>
                    
                    <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                      Ogni donazione, grande o piccola, contribuisce a fare la differenza nella vita dei bambini 
                      e adolescenti con malattie ematologiche rare.
                    </p>
                    
                    {/* Statistiche Impatto */}
                    <div className="space-y-6 mt-auto">
                      {/* Logo RHR */}
                      <div className="flex justify-center mb-8">
                        <img 
                          src={logoRHR} 
                          alt="Robin Hood Roma Logo" 
                          className="h-48 w-auto object-contain transform transition-all duration-300 hover:scale-105"
                        />
                      </div>

                      {/* <div className="border-t border-gray-200 pt-6">
                        <div className="grid grid-cols-2 gap-4">
                          <div className="text-center">
                            <div className="text-2xl font-bold text-accent mb-1">100+</div>
                            <div className="text-sm text-gray-600">Famiglie Aiutate</div>
                          </div>
                          <div className="text-center">
                            <div className="text-2xl font-bold text-accent mb-1">30+</div>
                            <div className="text-sm text-gray-600">Progetti Attivi</div>
                          </div>
                        </div>
                      </div> */}
                      
                      <div className="bg-primary/5 rounded-xl p-4">
                        <div className="flex items-center">
                          <div className="bg-primary rounded-full p-2 mr-4">
                            <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                          </div>
                          <div>
                            <h4 className="font-semibold text-primary">Donazione Sicura</h4>
                            <p className="text-sm text-gray-600">Le tue donazioni sono protette e sicure</p>
                          </div>
                        </div>
                      </div>
                      
                      {/* Pulsante Storie di Impatto - rimanda alla sezione in Chi Siamo */}
                      <div className="mt-6">
                        <button
                          onClick={() => navigate('/chi-siamo-storie', { state: { scrollTo: 'storie-di-impatto' } })}
                          className="w-full bg-red-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-red-700 transition duration-300 transform hover:scale-105 shadow-md"
                        >
                          Scopri le Storie di Impatto
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Colonna destra - Form Donazione */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden h-full">
                <div className="p-8 h-full flex flex-col">
                  <DonationForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Altre modalità di donazione */}
      <section className="py-16 px-4 bg-slate-100"> {/* Changed background from bg-white */}
        <div className="container mx-auto">
          <h3 className="text-4xl font-semibold mb-4 text-blue-700 text-center" style={{ fontVariant: 'small-caps' }}> {/* Increased font size from text-2xl */}
            Altre modalità di donazione
          </h3>
          
          <div className="max-w-3xl mx-auto">
            <div className="mb-6">
              <h4 className="text-2xl font-bold text-blue-700 mb-2">Bonifico Bancario</h4> {/* Increased font size from text-xl */}
              <p className="text-gray-700 mb-2 text-lg">Intestato a: Associazione Robin Hood Roma ODV</p> {/* Increased font size */}
              <p className="text-gray-700 mb-2 text-lg">IBAN: <span className="text-red-600 font-semibold">IT95C0306909606100000197431</span></p> {/* Increased font size */}
              <p className="text-gray-700 mb-4 text-lg">Causale: Donazione liberale</p> {/* Increased font size */}
            </div>
            
            <div className="mb-6">
              <h4 className="text-2xl font-bold text-blue-700 mb-2">5x1000</h4> {/* Increased font size from text-xl */}
              <p className="text-gray-700 mb-4 text-lg">Dona il tuo 5x1000 a Robin Hood Roma ODV, non ti costa nulla ma per noi significa tanto.</p> {/* Increased font size */}
              <p className="text-gray-700 mb-2 text-lg">Codice Fiscale: <span className="text-red-600 font-semibold">97353740588</span></p> {/* Increased font size */}
            </div>
            
            <div className="mb-6">
              <h4 className="font-medium text-xl mb-2 text-blue-700">Altre donazioni!</h4> {/* Increased font size from text-lg */}
              <p className="text-gray-700 text-lg"> {/* Increased font size */}
                Accettiamo anche donazioni di beni e servizi. Contattaci per maggiori informazioni su come donare materiali o offrire servizi professionali.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Come utilizziamo i fondi - NUOVA POSIZIONE 2 */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="container mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-blue-700">
            Come Utilizziamo i Fondi
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-primary/10 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-primary">Sostegno alla ricerca e alla conoscenza delle malattie rare ematologiche</h3>
              <p className="text-gray-600">
                Il 25% dei fondi raccolti è stato finora destinato al sostegno della ricerca e diffusione
                delle conoscenze sulle malattie ematologiche rare.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-primary/10 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-primary">Supporto alle Famiglie</h3>
              <p className="text-gray-600">
                Il 30% dei fondi viene utilizzato per fornire supporto economico, logistico e psicologico 
                alle famiglie dei pazienti durante il percorso di cura.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-primary/10 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-primary">Acquisto Attrezzature</h3>
              <p className="text-gray-600">
                Il 45% dei fondi raccolti è stato finora investito nell’acquisto di attrezzature (elettrocardiografi, reagenti)
                ed altro materiale destinati a garantire l’assistenza ai pazienti con malattie rare ematologiche seguiti
                in Ematologia, AOU Policlinico Umberto I.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action per Volontariato - NUOVA POSIZIONE 4 */}
      <section className="py-16 px-4 bg-primary/10">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 text-blue-700">Vuoi Fare la Differenza?</h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            Oltre alle donazioni, puoi supportare la nostra missione diventando volontario.
          </p>
          <button
            onClick={() => navigate('/volontari')}
            className="bg-primary text-white py-3 px-8 rounded-full text-lg font-bold hover:bg-primary/90 transition duration-300"
          >
            Diventa Volontario
          </button>
          <button
              onClick={() => navigate('/soci')}
              className="ml-16 bg-accent text-white py-3 px-8 rounded-full text-lg font-bold hover:bg-accent/90 transition duration-300"
            >
              Diventa Socio
            </button>
        </div>
      </section>
    </>
  );
};

export default Sostienici;
